module.exports = __webpack_public_path__ + "img/band-black.cc88cb91.png";